import moment from 'moment';

import { DATE_TIME } from 'src/app/constants/dateTimeFormat';
import { thousandFormat } from 'src/app/constants/formatters';
import { WrappedColumn } from '../Table/WrappedColumn';

export const generate = (columns: WrappedColumn[], rows: any, filename: string, reportName: string) => {
  if (typeof window !== 'undefined') {
    const jsPDF = require('jspdf');
    require('jspdf-autotable');
    const doc = new jsPDF({
      orientation: 'landscape'
    });
    const totalPagesExp = '{total_pages_count_string}';
    const head = [columns.map(col => col.name)];
    doc.autoTable({
      alternateRowStyles: {
        fillColor: [255, 250, 242]
      },
      body: formatRowsWithThousandSeparator(rows),
      didDrawPage: (data: any) => {
        // Header
        doc.setFontSize(14);
        doc.text(reportName, data.settings.margin.left, 10);

        // Footer
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.setFontSize(8);
        doc.text(moment(new Date()).format(DATE_TIME), data.settings.margin.left, pageHeight - 10);
        let footerText = `Page ${doc.internal.getNumberOfPages()}`;
        if (typeof doc.putTotalPages === 'function') {
          footerText = `${footerText} of ${totalPagesExp}`;
        }
        doc.text(footerText, doc.internal.pageSize.getWidth() - data.settings.margin.right - 30, pageHeight - 10);
      },
      head,
      headStyles: {
        fillColor: [240, 166, 0],
        textColor: 255
      }
    });
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    doc.save(`${filename}.pdf`);
  }
};

const formatRowsWithThousandSeparator = (rows: any[]) => {
  return rows.map((row: any[]) => {
    return row.map((cell: any) => {
      if (typeof cell === 'number') {
        return thousandFormat(cell);
      } else {
        return cell;
      }
    });
  });
};
